import { Global } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/material/styles";

import * as React from "react";

import { pullerIcon, thumbsDownLightIcon, thumbsUpGreyIcon } from "../../../constant";
import styles from "./swipeableEdgeDrawer.module.scss";
import { colors, sp } from "../../../styles/design-tokens";

const drawerBleeding = 0;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  openFeedbackDrawerActionFlag: boolean;
  setOpenFeedbackDrawerActionFlag: any;
  onNeedImprovementClick: any;
  onGoogleResultsClick?: any;
}

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor: `var(--zv-canvas, ${grey[100]})`,
  ...theme.applyStyles("dark", {
    backgroundColor: theme.palette.background.default,
  }),
}));

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: `var(--zv-surface, ${colors.neutral.white})`,
  ...theme.applyStyles("dark", {
    backgroundColor: grey[800],
  }),
}));

// const Puller = styled("div")(({ theme }) => ({
//   width: 30,
//   height: 6,
//   backgroundColor: grey[300],
//   borderRadius: 3,
//   position: "absolute",
//   top: 8,
//   left: "calc(50% - 15px)",
//   ...theme.applyStyles("dark", {
//     backgroundColor: grey[900],
//   }),
// }));

export default function SwipeableEdgeDrawer(props: Props) {
  const {
    window,
    openFeedbackDrawerActionFlag,
    setOpenFeedbackDrawerActionFlag,
    onNeedImprovementClick,
    onGoogleResultsClick = () => {},
  } = props;

  // This is used only for the example
  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(220px - ${drawerBleeding}px)`,
            overflow: "hidden",
            margin: sp(0, 10),
            // Theme Studio dialog radius (top corners); fallback = shipped.
            borderRadius: "var(--zv-dialog-radius, 10px) var(--zv-dialog-radius, 10px) 0 0",
            backgroundColor: "transparent",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "none",
          },
        }}
      />
      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={openFeedbackDrawerActionFlag}
        onClose={() => setOpenFeedbackDrawerActionFlag(false)}
        onOpen={() => setOpenFeedbackDrawerActionFlag(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        keepMounted
      >
        <StyledBox
          sx={{
            px: 3,
            pb: 2,
            pt: 2,
            height: "100%",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
          }}
          className={styles.drawerContainer}
        >
          <img src={pullerIcon} className={styles.puller} alt="puller icon" />
          <div className={styles.actionBtnContainer}>
            <div
              className={styles.actionBtn}
              onClick={() => {
                onGoogleResultsClick();
                setOpenFeedbackDrawerActionFlag(false);
              }}
            >
              <img src={thumbsUpGreyIcon} alt="good results" className="zv-icon" />
              <h1>Good results</h1>
            </div>
            <div
              className={styles.actionBtn}
              onClick={() => {
                onNeedImprovementClick();
                setOpenFeedbackDrawerActionFlag(false);
              }}
            >
              <img src={thumbsDownLightIcon} alt="need improvement" className="zv-icon" />
              <h1>Needs improvement</h1>
            </div>
          </div>
        </StyledBox>
      </SwipeableDrawer>
    </Root>
  );
}
